module.exports = __webpack_public_path__ + "static/media/img_dog_bob.c69ae952.svg";